export default {
    methods: {
        scrollTo(top = 0, left = 0) {
            window.scrollTo({
                top: top,
                left: left,
                behaviour: 'smooth'
            });
        }
    }
};
